<div class="modal-content">
    @if (isFormInitialized) {
    <div mat-dialog-title class="d-flex justify-content-between flex-row modal-header align-items-center">

        <h3 class="d-flex flex-column justify-content-center">
            @if (runnerName || bib) {
            <div>
                <span>
                    @if (bib) {
                    <span>{{bib}} -</span>
                    }
                    <span>{{runnerName | titlecase}}</span>
                    @if (country) {
                    <img [src]="countryFlagUrl" [alt]="country" class="country-flag" draggable="false"
                        crossorigin="anonymous">
                    }
                </span>
            </div>
            }

            @if (nickname) {<span class="nickname">{{nickname}}</span>}
            @if (club) {<span class="club">{{club}}</span>}

        </h3>

        <button (click)="close()" class="btn btn-light btn-close"></button>

    </div>

    <mat-dialog-content class="modal-body">
        <form [formGroup]="runnerFg" (submit)="submit()" class="form-runner">
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="d-flex flex-row justify-content-center align-items-center gap-2">
                            <span>Informations personnelles</span>
                        </div>
                    </ng-template>
                    <ng-template matTabContent>


                        <section class="field-wrapper">
                            <div class="grid-twin">
                                <mat-form-field appearance="outline">
                                    <mat-label>Nom</mat-label>
                                    <input matInput type="text" formControlName="name">
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Prénom</mat-label>
                                    <input matInput type="text" formControlName="firstName">
                                </mat-form-field>
                            </div>


                            <mat-form-field appearance="outline">
                                <mat-label>Surnom</mat-label>
                                <input matInput type="text" formControlName="nickname">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Club / team</mat-label>
                                <input matInput type="text" formControlName="club">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>E-mail</mat-label>
                                <input matInput type="email" formControlName="mail">
                            </mat-form-field>

                            <div class="grid-twin">

                                <mat-form-field appearance="outline">
                                    <mat-label>Ville</mat-label>
                                    <input matInput type="text" formControlName="town">
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Pays</mat-label>
                                    <input matInput type="text" formControlName="country">
                                </mat-form-field>
                            </div>

                            <div class="grid-twin">
                                <mat-form-field appearance="outline">
                                    <mat-label>Genre</mat-label>
                                    <mat-select formControlName="sex">
                                        <mat-option value="H">Homme</mat-option>
                                        <mat-option value="F">Femme</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Date de naissance</mat-label>
                                    <input matInput type="datetime" formControlName="birthdate">
                                </mat-form-field>
                            </div>



                            <div class="grid-twin">
                                <mat-form-field appearance="outline">
                                    <mat-label>Catégorie de l'évènement</mat-label>
                                    <input matInput type="text" formControlName="category">
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Catégorie de la fédération</mat-label>
                                    <input matInput type="text" formControlName="category_federal">
                                </mat-form-field>
                            </div>



                        </section>

                    </ng-template>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="d-flex flex-row justify-content-center align-items-center gap-2">
                            <span>Chronométrage</span>
                        </div>
                    </ng-template>
                    <ng-template matTabContent>

                        <section class="field-wrapper">
                            <mat-form-field appearance="outline">
                                <mat-label>Epreuves</mat-label>
                                <mat-select formControlName="raceId">
                                    @for (race of races$ | async; track $index) {
                                    <mat-option [value]="race.id">{{race.name}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <div>
                                <mat-slide-toggle [(ngModel)]="bibChip">Dissocier le numéro de dossard du numéro de
                                    puce</mat-slide-toggle>
                                <div class="grid-twin">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Numéro de dossard</mat-label>
                                        <input matInput type="number" formControlName="bib">
                                    </mat-form-field>

                                    @if (bibChip) {
                                    <mat-form-field appearance="outline">
                                        <mat-label>Numéro de puce</mat-label>
                                        <input matInput type="number" formControlName="chip">
                                    </mat-form-field>
                                    }
                                </div>


                            </div>

                            <mat-form-field appearance="outline">
                                <mat-label>Statut</mat-label>
                                <mat-select formControlName="status">
                                    @for (status of runnerStatus; track $index) {
                                    <mat-option [value]="status">
                                        {{runnerStatusLabel(status)}}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </section>


                    </ng-template>
                </mat-tab>

                @if (runner?.id) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="d-flex flex-row justify-content-center align-items-center gap-2">
                            <span>Passages</span>
                        </div>
                    </ng-template>
                    <ng-template matTabContent>
                        <div class="mt-2 mb-2">
                            <!-- <aoe-passages-recap [runner]="runner"></aoe-passages-recap> -->
                        </div>
                    </ng-template>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="d-flex flex-row justify-content-center align-items-center gap-2">
                            <span>Classement</span>
                        </div>
                    </ng-template>
                    <ng-template matTabContent>
                        <div class="mt-2 mb-2">
                        </div>
                    </ng-template>
                </mat-tab>
                }



            </mat-tab-group>
            <button matButton="filled" type="submit" [disabled]="runnerFg.invalid">
                Enregistrer
            </button>
        </form>

    </mat-dialog-content>
    } @else {
    Initialisation du formulaire
    }
</div>

<ng-template #iconValidForm>
    <mat-icon [svgIcon]="icons.CHECK"></mat-icon>
</ng-template>
<ng-template #iconInvalidForm>
    <mat-icon [svgIcon]="icons.RED_CROSS"></mat-icon>
</ng-template>